<template>
  <router-link v-if="destination" :to="destination" :aria-label="'Abrir graficador de ' + ticker"><slot>Ver gráfico</slot><span aria-hidden="true"> ↗</span></router-link>
</template>
<script>
import { interfacePreferencesController } from '@/shells/services/interfacePreferencesController';
import { forumStockChartLocation } from '../models/forumStock';
export default {
  name: 'ForumStockChartLink', props: { ticker: { type: String, required: true } },
  computed: {
    destination() {
      const user = this.$store?.getters._g_User || {};
      const preference = interfacePreferencesController.stateFor(user.uid).preferences.shell;
      return forumStockChartLocation({ ticker: this.ticker, route: this.$route, preference, user });
    }
  }
};
</script>
